module.exports = __webpack_public_path__ + "img/hashtags_generator.2d066943.svg";